import React from "react";
import { Userx } from "../../../DTO/Userx";
import { rolesBodyTemplate } from "../../../utilities/rolesBodyTemplate";

interface UserListProps {
    users: Userx[];
    loading: boolean;
    onEditUser: (user: Userx) => void;
    onDeleteUser: (user: Userx) => void;
}

const UserListComponent: React.FC<UserListProps> = ({
                                                        users,
                                                        loading,
                                                        onEditUser,
                                                        onDeleteUser,
                                                    }) => (
    <div className="overflow-x-auto bg-surface rounded border border-border">
        <table className="min-w-full">
            <thead className="bg-background">
            <tr>
                {["Username", "First Name", "Last Name", "Roles", "Enabled", "Edit", "Delete"].map(
                    (col) => (
                        <th
                            key={col}
                            className="text-left px-4 py-2 text-on-surface font-medium border-b border-border"
                        >
                            {col}
                        </th>
                    )
                )}
            </tr>
            </thead>
            <tbody>
            {loading ? (
                <tr>
                    <td colSpan={7} className="text-center py-4 text-text-secondary">
                        Loading users...
                    </td>
                </tr>
            ) : (
                users.map((user) => (
                    <tr
                        key={user.username}
                        className="hover:bg-background transition-colors"
                    >
                        <td className="px-4 py-2 text-on-surface">{user.username}</td>
                        <td className="px-4 py-2 text-on-surface">{user.firstName}</td>
                        <td className="px-4 py-2 text-on-surface">{user.lastName}</td>
                        <td className="px-4 py-2 text-on-surface">
                            {rolesBodyTemplate(user)}
                        </td>
                        <td className="px-4 py-2">
                            <input
                                type="checkbox"
                                checked={user.enabled}
                                disabled
                                className="h-4 w-4 text-primary bg-surface border border-border rounded"
                            />
                        </td>
                        <td className="px-4 py-2">
                            <button
                                onClick={() => onEditUser(user)}
                                className="text-primary hover:text-primary-variant transition-colors font-medium"
                                aria-label={`Details for ${user.username}`}
                            >
                                Details
                            </button>
                        </td>
                        <td className="px-4 py-2">
                            <button
                                onClick={() => onDeleteUser(user)}
                                className="text-error hover:text-error/80 transition-colors font-medium"
                                aria-label={`Delete ${user.username}`}
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                ))
            )}
            </tbody>
        </table>
    </div>
);

export default UserListComponent;
